/**
 * Canonical list of target roles used across Resume Analyzer, Skill-Gap,
 * Mock Interview, and Profile. Keep this file as the single source of truth —
 * import from here, do not inline role arrays.
 *
 * Grouped for the UI so leadership / AI roles are easy to find.
 */
export const TARGET_ROLE_GROUPS = [
  {
    label: "Engineering",
    roles: [
      "Software Engineer",
      "Full Stack Developer",
      "Frontend Developer",
      "Backend Developer",
    ],
  },
  {
    label: "AI & Data",
    roles: [
      "AI Engineer",
      "Generative AI Engineer",
      "Machine Learning Engineer",
      "MLOps Engineer",
      "Prompt Engineer",
      "Data Scientist",
      "Data Analyst",
      "Data Engineer",
    ],
  },
  {
    label: "Infra & Reliability",
    roles: [
      "DevOps Engineer",
      "Sr. DevOps Engineer",
      "Site Reliability Engineer",
      "Sr. Site Reliability Engineer",
      "Cloud Engineer",
      "Security Engineer",
      "Cyber Security Analyst",
    ],
  },
  {
    label: "Quality & Delivery",
    roles: [
      "QA Engineer",
      "Scrum Master",
      "Release Manager",
      "Product Manager",
    ],
  },
  {
    label: "Leadership & Management",
    roles: [
      "Technical Lead",
      "Engineering Manager",
      "Technical Program Manager",
      "Chief Technology Officer (CTO)",
    ],
  },
];

// Flat list for places that just need the strings
export const TARGET_ROLES = TARGET_ROLE_GROUPS.flatMap((g) => g.roles);

// Roles that should trigger leadership/management emphasis in AI prompts
export const LEADERSHIP_ROLES = new Set([
  "Technical Lead",
  "Engineering Manager",
  "Technical Program Manager",
  "Chief Technology Officer (CTO)",
]);

export function isLeadershipRole(role) {
  return LEADERSHIP_ROLES.has(role);
}
